import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from "./classes/BaseService";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class GenresService extends BaseService{

  apiUrl: string = "GenreList.php?";

  constructor(protected http: HttpClient) { 
    super(http);
  }

  getGenres(store: string, country: string, mediaType) {
    
    if(mediaType == "buymovies" || mediaType == "rentalmovies"){
      mediaType = "movies";
    }
    else if(mediaType == "albums" || mediaType == "singles"){
      mediaType = "music";
    }
    else if(mediaType == "seasons") {
      mediaType = "tv";
    }

    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("country", country),
      new UrlParam("mediaType", mediaType)
    );
    
    return this.get(url);
  }

}
